import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class CardText extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['card-text']: true
        });

        return (
            <div className={classNames} {...props}>
                {children}
            </div>
        );
    }
}

CardText.defaultProps = {};

export default CardText;
